<template>
  <div class="meal-tab">
    <span class="item" :class="{active: value == index}" :style="{width: (100 / options.length) + '%'}" v-for="(item,index) in options" @click="click(index)" :key="index">{{item.type}}</span>
  </div>
</template>
<script>
export default {
  name: 'mealtabs',
  data() {
    return {
    }
  },
  props: ['options', 'value'],
  methods: {
    click(idx) {
      this.$emit('input', idx)
    }
  }
}
</script>
<style lang="scss" scoped>
.meal-tab {
  span.item {
    height: 40px;
    display: inline-block;
    line-height: 40px;
    text-align: center;
    border: 1px solid var(--contact-division-color);
    border-right: none;
    cursor: pointer;
    &:last-child {
      border-right: 1px solid var(--contact-division-color);
    }
    &.active {
      background: var(--theme-color);
      color: #fff;
      border: 1px solid var(--theme-color);
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/global/mealtabs.vue